<script lang="ts">
export default {
  name: 'Chip',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    /** Optional text to render inside the chip. If omitted, the default slot is used. */
    label?: string;
    /** Visual style of the chip. */
    variant?: 'solid' | 'outline';
    /** Additional Tailwind classes to control colors (e.g. 'bg-primary text-white'). */
    colorClass?: string;
    /** Size of the chip. */
    size?: 'sm' | 'md';
    /** Extra classes to append to the chip container. */
    class?: string;
  }>(),
  {
    variant: 'solid',
    size: 'md',
  },
);

const baseClasses = computed(() => {
  const classes = [
    'inline-flex',
    'items-center',
    'justify-center',
    'rounded',
    'font-bold',
    'uppercase',
    'tracking-wide',
    'text-center',
  ];

  // Size
  if (props.size === 'sm') {
    classes.push('px-2', 'py-0.5', 'text-xs');
  } else {
    classes.push('px-2.5', 'py-1', 'text-xs');
  }

  // Variant
  if (props.variant === 'outline') {
    classes.push('border', 'border-current', 'bg-transparent');
  }

  if (props.colorClass) {
    classes.push(props.colorClass);
  }

  if (props.class) {
    classes.push(props.class);
  }

  return classes.join(' ');
});
</script>

<template>
  <span :class="baseClasses">
    <slot>
      {{ label }}
    </slot>
  </span>
</template>

